import { createSelector } from 'reselect';
export var getState = function (state) { return state.refundInfo; };
export var getIsDocumentConfirmationRequired = createSelector(getState, function (refundInfo) { return refundInfo.confirmationDocsAreRequired; });
export var getPrices = createSelector(getState, function (refundInfo) { return refundInfo.prices; });
export var getReasonsInfo = createSelector([getState], function (refundInfo) { return refundInfo.unvoluntaryReasonsInfo; });
export var getIsDocUploadRequired = createSelector([getState], function (refundInfo) { return refundInfo.confirmationDocsAreRequired; });
